import { Button, cn } from '@repo/ui';
import { LogOut } from 'lucide-react';
import { NavLink } from 'react-router';

import { APP_ROUTES } from '@/constants/app-routes';

interface MobileNavProps {
  onSignOut: () => void;
}

const LINKS = [
  { to: APP_ROUTES.people, label: 'People', end: false },
  { to: APP_ROUTES.applications, label: 'Applications', end: false },
];

/** The shared sidebar is hidden below the lg breakpoint, so a phone gets this strip instead. */
export function MobileNav({ onSignOut }: MobileNavProps) {
  return (
    <nav
      aria-label="Platform"
      className="-mx-5 -mt-7 mb-4 flex items-center gap-1 border-b border-border bg-card px-3 py-2 sm:-mx-8 sm:px-6 lg:hidden"
    >
      {LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.end}
          className={({ isActive }) =>
            cn(
              'rounded-md px-3 py-1.5 text-sm font-medium text-muted-foreground',
              isActive && 'bg-primary-soft text-primary',
            )
          }
        >
          {link.label}
        </NavLink>
      ))}

      <Button variant="ghost" size="sm" className="ml-auto" onClick={onSignOut}>
        <LogOut className="size-4" aria-hidden />
        Sign out
      </Button>
    </nav>
  );
}
